import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomInputGroupModule } from '../custom-input-group/custom-input-group.module';
import { FormInputErrorModule } from '../form-input-error/form-input-error.module';
import { PipesModule } from '../pipes/pipes.module';
import { RemovePoliyModalComponent } from './remove-poliy-modal.component';



@NgModule({
  declarations: [RemovePoliyModalComponent],
  imports: [
    CommonModule, PipesModule, FormsModule, ReactiveFormsModule, FormInputErrorModule, CustomInputGroupModule
  ],
  exports: [
    RemovePoliyModalComponent
  ]
})
export class RemovePoliyModalModule { }
